const GLOBAL_LOADER_EVENT = 'app:global-loader';

let activeRequestCount = 0;

const emitState = () => {
  if (typeof window === 'undefined') {
    return;
  }

  window.dispatchEvent(
    new CustomEvent(GLOBAL_LOADER_EVENT, {
      detail: {
        active: activeRequestCount > 0,
        count: activeRequestCount,
      },
    })
  );
};

export const startGlobalLoader = () => {
  activeRequestCount += 1;
  emitState();
};

export const stopGlobalLoader = () => {
  activeRequestCount = Math.max(0, activeRequestCount - 1);
  emitState();
};

export const resetGlobalLoader = () => {
  activeRequestCount = 0;
  emitState();
};

export const subscribeGlobalLoader = (callback) => {
  if (typeof window === 'undefined' || typeof callback !== 'function') {
    return () => {};
  }

  const listener = (event) => {
    callback(event?.detail || { active: false, count: 0 });
  };

  window.addEventListener(GLOBAL_LOADER_EVENT, listener);
  callback({ active: activeRequestCount > 0, count: activeRequestCount });

  return () => {
    window.removeEventListener(GLOBAL_LOADER_EVENT, listener);
  };
};
